<div style="border: solid 1px #dbdbdb; border-radius: 0.5em;">
    <ng-content></ng-content>
</div>